import React, { useRef, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  CardContent,
  Card,
  Button,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Stack,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import FindReplaceIcon from "@mui/icons-material/FindReplace";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HallCropEdit from "./HallCropEdit";
import axios from "axios";
import { ADMIN, API_ENDPOINT } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { getHeader, toastError } from "../../utils/util";
import RdMyModal from "../../widgets/myModal/RdMyModal";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
function UploadHall({
  onBack,
  color,
  strokeWidth,
  points,
  rectangle,
  selectedMode,
}) {
  const navigate = useNavigate();
  const cardRef = useRef(null);
  const imgFile = useRef(null);
  const [image, setImage] = useState(null);
  const [hallName, setHallName] = useState(null);

  const [gMenuEl, setGmenuEl] = useState(null);
  const [hMenuEl, setHmenuEl] = useState(null);
  const [showImageCrop, setShowImageCrop] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleGeneralPlanEdit = (e) => {
    setGmenuEl(e.target);
  };
  const handleGmenuClick = (e, m) => {
    setGmenuEl(null);
    setShowImageCrop(true);
  };
  const handleHmenuClick = (e, m) => {};
  const onSave = () => {
    const shape = {
      type: selectedMode,
      shape: selectedMode === "Rectangle" ? rectangle : points,
    };
    addHall(1, image, hallName, shape);
  };
  const addHall = async (eventId, image, name, shape) => {
    try {
      setSaving(true);
      const { data } = await axios.post(
        `${API_ENDPOINT}admin/add-hall`,
        {
          eventId: eventId,
          color: color,
          strokeWidth: strokeWidth,
          image: image,
          name: name,
          shape: shape,
        },
        getHeader(ADMIN)
      );
      toast.success(data.message);
      setTimeout(() => {
        document.location.reload();
      }, 300);
    } catch (error) {
      toastError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box m={2}>
      <RdMyModal
        showModal={showImageCrop}
        setShowModal={setShowImageCrop}
        modalC={
          <HallCropEdit
            setPic={setImage}
            show={showImageCrop}
            setShow={setShowImageCrop}
          />
        }
      />
      <Button
        variant="text"
        sx={{
          textTransform: "none",
          "& .MuiButton-startIcon": {
            marginRight: "0", // Adjust this value to your desired spacing
          },
        }}
        startIcon={<ArrowBackIosIcon />}
        size="small"
        onClick={onBack}
      >
        Back
      </Button>
      <input
        ref={imgFile}
        type="file"
        style={{ display: "none" }}
        accept=".jpg, .jpeg, .png"
      />
      <Menu
        anchorEl={gMenuEl}
        open={Boolean(gMenuEl)}
        onClose={() => setGmenuEl(null)}
      >
        <MenuItem onClick={(e) => handleGmenuClick(e, "Edit Image")}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          Edit Image
        </MenuItem>
        <MenuItem onClick={(e) => handleGmenuClick(e, "Replace Image")}>
          <ListItemIcon>
            <FindReplaceIcon fontSize="small" />
          </ListItemIcon>
          Replace Image
        </MenuItem>
        <Divider />
        <MenuItem
          sx={{ color: "red" }}
          onClick={(e) => handleGmenuClick(e, "Delete Image")}
        >
          <ListItemIcon>
            <DeleteOutlineIcon sx={{ color: "red" }} fontSize="small" />
          </ListItemIcon>
          Delete Image
        </MenuItem>
      </Menu>
      <Menu
        anchorEl={hMenuEl}
        open={Boolean(hMenuEl)}
        onClose={() => setHmenuEl(null)}
      >
        <MenuItem onClick={(e) => handleHmenuClick(e, "Edit Hall")}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          Edit Image
        </MenuItem>
        <MenuItem onClick={(e) => handleHmenuClick(e, "Add Stand")}>
          <ListItemIcon>
            <AddIcon fontSize="small" />
          </ListItemIcon>
          Add Stand
        </MenuItem>
        <Divider />
        <MenuItem
          sx={{ color: "red" }}
          onClick={(e) => handleHmenuClick(e, "Delete Hall")}
        >
          <ListItemIcon>
            <DeleteOutlineIcon sx={{ color: "red" }} fontSize="small" />
          </ListItemIcon>
          Delete Hall
        </MenuItem>
      </Menu>

      <Grid marginTop={1} container spacing={2}>
        <Grid item xs={7}>
          <Card>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  // Adjust as per your needs
                }}
              >
                <Typography variant="h6">Hall Image</Typography>

                <IconButton
                  onClick={handleGeneralPlanEdit}
                  color="primary"
                  aria-label="edit"
                >
                  <EditIcon />
                </IconButton>
              </Box>

              <Card
                ref={cardRef}
                sx={{
                  mt: 2,
                  padding: 2,
                  height: "400px",
                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center", // Centers the canvas horizontally
                  alignItems: "center",
                }}
                variant="outlined"
              >
                {image === null ? (
                  <Box
                    onClick={() => setShowImageCrop(true)}
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      border: "2px dashed gray",
                      padding: 4,
                      cursor: "pointer",
                    }}
                  >
                    <Typography variant="h6">
                      Click to upload a Hall image
                    </Typography>
                    <Typography variant="body2">
                      Only images (JPG/JPEG, PNG) less than 2mb are allowed for
                      upload.
                    </Typography>
                  </Box>
                ) : (
                  <img
                    src={image}
                    alt=""
                    style={{ display: "block", width: "90%" }}
                  />
                )}
              </Card>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={5}>
          <Card>
            <CardContent>
              <Box>
                <Box
                  sx={{
                    mb: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    // Adjust as per your needs
                  }}
                >
                  <Typography variant="h6">Add New Hall</Typography>
                </Box>

                <Box sx={{ mt: 2 }}>
                  <TextField
                    sx={{ mb: 1 }}
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={hallName}
                    onChange={(e) => setHallName(e.target.value)}
                    label="Hall Name"
                  />
                  <FormGroup row>
                    <FormControlLabel
                      control={<Checkbox size="small" />}
                      label={
                        <Typography variant="body2">Conference Hall</Typography>
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox size="small" />}
                      label={
                        <Typography variant="body2">Check-in Zone</Typography>
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox size="small" />}
                      label={
                        <Typography variant="body2">
                          Hide on Front-End
                        </Typography>
                      }
                    />
                  </FormGroup>
                  {/* <SimpleCalendar month={9} year={2023} /> */}
                  <Stack
                    spacing={2}
                    marginTop={2}
                    direction="row"
                    sx={{ width: "100%" }}
                  >
                    <Button
                      onClick={onBack}
                      size="small"
                      variant="outlined"
                      sx={{ flex: 1 }}
                    >
                      Cancel
                    </Button>
                    <LoadingButton
                      loading={saving}
                      onClick={onSave}
                      size="small"
                      variant="contained"
                      sx={{ flex: 1 }}
                    >
                      Save
                    </LoadingButton>
                  </Stack>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default UploadHall;
